import React, { useState } from 'react';
import { Flex } from 'antd';

import { PaymentSystemCard } from './PaymentSystemCard';
import { useAppSelector } from '../../../../../store';
import { selectPaymentSystem } from '../store/paymentSystem.slice';

export const PaymentSystemList = ({ loading }: { loading: boolean }) => {
    const { data } = useAppSelector(selectPaymentSystem);

    const [openSystem, setOpenSystem] = useState<string | null>(null);

    return (
        <Flex vertical gap={24}>
            {data.map(system => (
                <PaymentSystemCard
                    key={system.name}
                    loading={loading}
                    openSystem={openSystem}
                    setOpenSystem={setOpenSystem}
                    system={{
                        ...data.find(item => item.name === system.name),
                    }}
                />
            ))}
        </Flex>
    );
};
